"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLabel = createLabel;
exports.rotateAllLabels = rotateAllLabels;
exports.rotateLabelsOnLayer = rotateLabelsOnLayer;
exports.updateLabel = updateLabel;
var _konva = _interopRequireDefault(require("konva"));
var _Layer = require("../Layer");
var _excluded = ["parent", "position", "offset", "text", "x", "y", "center", "id"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var groupName = "label";
var shapeName = "text";
function createLabel(_ref) {
  var parent = _ref.parent,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? {
      x: 0,
      y: 0
    } : _ref$position,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? {
      x: 0,
      y: 0
    } : _ref$offset,
    text = _ref.text,
    x = _ref.x,
    y = _ref.y,
    center = _ref.center,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? "" : _ref$id,
    rest = _objectWithoutProperties(_ref, _excluded);
  var group = new _konva.default.Group({
    draggable: false,
    id: id,
    name: groupName,
    position: position
  });
  var label = new _konva.default.Text(_objectSpread({
    name: shapeName,
    text: text,
    fontSize: 14,
    fontFamily: "Arial",
    fill: "white",
    fontStyle: "bold",
    stroke: "black",
    strokeWidth: 0.5
  }, rest));

  // center text if true
  if (center) {
    var boundingBox = label.getClientRect();
    var _center = {
      x: -boundingBox.width / 2,
      y: -boundingBox.height / 2
    };
    label.position(_center);
  }

  // apply offset manually to position
  if (offset) {
    var _position = label.position();
    // apply as negative offset
    var shift = {
      x: _position.x - offset.x,
      y: _position.y - offset.y
    };
    label.position(shift);
  }
  group.add(label);
  if (parent != null) {
    parent.add(group);
    return true;
  } else {
    return group;
  }
}
function rotateLabelsOnLayer(layer, deg) {
  (0, _Layer.rotateTypeOnLayer)(layer, "Text", deg);
}
function rotateAllLabels(stage, deg) {
  // check stage and layers are accessible
  if (!stage) return;

  // rotate each label on the stage
  stage.getChildren().forEach(function (layer) {
    rotateLabelsOnLayer(layer, deg);
  });
}
function updateLabel(_ref2) {
  var ref = _ref2.ref,
    text = _ref2.text,
    position = _ref2.position,
    _ref2$display = _ref2.display,
    display = _ref2$display === void 0 ? true : _ref2$display;
  // get the text child inside the label group
  var textNode = ref.find(".text")[0];

  // set absolute position on the group
  if (position) ref.absolutePosition(position);

  // update the text inside the group
  if (text) textNode.text(text);

  // update whether label is displayed
  if (display) {
    textNode.show();
  } else {
    textNode.hide();
  }
}